var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonOrganizationChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -971.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Organization-chart",
    transform: "translate(1206.000000, 971.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,25.6875 L21,25.6875 L21,21.8125 L32,21.8125 L32,31.5 L21,31.5 L21,27.625 L15,27.625 L15,23.75 L11,23.75 L11,27.625 L0,27.625 L0,17.9375 L11,17.9375 L11,21.812 L15,21.812 L15,15.03125 L8,15.03125 L8,0.5 L23,0.5 L23,15.03125 L17,15.03125 L17,25.6875 Z M26.641,27.613375 L26.118,27.613375 C24.691,27.6153125 23.528,28.721625 23.5,30.1040312 L23.5,30.1040312 L29.212,30.1040312 C29.212,28.7284062 28.061,27.613375 26.641,27.613375 L26.641,27.613375 Z M26.286,23.8759375 C25.457,23.8759375 24.786,24.5269375 24.786,25.3290625 C24.786,26.1311875 25.457,26.7821875 26.286,26.7821875 C27.114,26.7821875 27.786,26.1311875 27.786,25.3290625 C27.786,24.5269375 27.114,23.8759375 26.286,23.8759375 Z M5.641,23.738375 L5.119,23.738375 C3.691,23.7403125 2.528,24.846625 2.5,26.2290312 L2.5,26.2290312 L8.212,26.2290312 C8.212,24.8534063 7.061,23.738375 5.641,23.738375 L5.641,23.738375 Z M5.286,20.0009375 C4.457,20.0009375 3.786,20.6519375 3.786,21.4540625 C3.786,22.2561875 4.457,22.9071875 5.286,22.9071875 C6.114,22.9071875 6.786,22.2561875 6.786,21.4540625 C6.786,20.6519375 6.114,20.0009375 5.286,20.0009375 Z M19,8.25 L15.268,8.25 C12.75,8.25290625 11.049,9.6856875 11,12.125 L11,12.125 L19,12.125 L19,8.25 Z M15.563,3.40625 C14.458,3.40625 13.563,4.27425 13.563,5.34375 C13.563,6.41325 14.458,7.28125 15.563,7.28125 C16.667,7.28125 17.563,6.41325 17.563,5.34375 C17.563,4.27425 16.667,3.40625 15.563,3.40625 Z",
    id: 218
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonOrganizationChart);
export default __webpack_public_path__ + "static/media/common-organization-chart.74c45565.svg";
export { ForwardRef as ReactComponent };